/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface ProductApplicationMethodsService {
  /** @summary Get All */
  getAllProductApplicationMethodsGet: {
    /** @summary Get All */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetAllProductApplicationMethodsGetSchema,
            GetAllProductApplicationMethodsGetParameters,
            TMeta,
            TSignal
          >
        | (QueryFnOptionsByParameters<GetAllProductApplicationMethodsGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: GetAllProductApplicationMethodsGetSchema,
        options: {
          parameters: GetAllProductApplicationMethodsGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetAllProductApplicationMethodsGetData, GetAllProductApplicationMethodsGetError>>
    ): Promise<RequestFnResponse<GetAllProductApplicationMethodsGetData, GetAllProductApplicationMethodsGetError>>;
    /** @summary Get All */
    getQueryKey(
      parameters: DeepReadonly<GetAllProductApplicationMethodsGetParameters> | void
    ): ServiceOperationQueryKey<GetAllProductApplicationMethodsGetSchema, GetAllProductApplicationMethodsGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.productApplicationMethodsService.getAllProductApplicationMethodsGet.useQuery()
     * ```
     */
    useQuery<TData = GetAllProductApplicationMethodsGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetAllProductApplicationMethodsGetSchema,
            GetAllProductApplicationMethodsGetParameters
          >
        | (DeepReadonly<GetAllProductApplicationMethodsGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          GetAllProductApplicationMethodsGetData,
          GetAllProductApplicationMethodsGetError,
          TData,
          ServiceOperationQueryKey<
            GetAllProductApplicationMethodsGetSchema,
            GetAllProductApplicationMethodsGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetAllProductApplicationMethodsGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.productApplicationMethodsService.getAllProductApplicationMethodsGet.useQuery()
     * ```
     */
    useQuery<TData = GetAllProductApplicationMethodsGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetAllProductApplicationMethodsGetSchema,
            GetAllProductApplicationMethodsGetParameters
          >
        | (DeepReadonly<GetAllProductApplicationMethodsGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          GetAllProductApplicationMethodsGetData,
          GetAllProductApplicationMethodsGetError,
          TData,
          ServiceOperationQueryKey<
            GetAllProductApplicationMethodsGetSchema,
            GetAllProductApplicationMethodsGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetAllProductApplicationMethodsGetError>>;
    /** @summary Get All */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetAllProductApplicationMethodsGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<
      GetAllProductApplicationMethodsGetSchema,
      GetAllProductApplicationMethodsGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.productApplicationMethodsService.getAllProductApplicationMethodsGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAllProductApplicationMethodsGetParameters,
      TQueryFnData = GetAllProductApplicationMethodsGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAllProductApplicationMethodsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetAllProductApplicationMethodsGetSchema,
            GetAllProductApplicationMethodsGetParameters
          >
        | (DeepReadonly<GetAllProductApplicationMethodsGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAllProductApplicationMethodsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetAllProductApplicationMethodsGetSchema,
            GetAllProductApplicationMethodsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetAllProductApplicationMethodsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.productApplicationMethodsService.getAllProductApplicationMethodsGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAllProductApplicationMethodsGetParameters,
      TQueryFnData = GetAllProductApplicationMethodsGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAllProductApplicationMethodsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetAllProductApplicationMethodsGetSchema,
            GetAllProductApplicationMethodsGetParameters
          >
        | (DeepReadonly<GetAllProductApplicationMethodsGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAllProductApplicationMethodsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetAllProductApplicationMethodsGetSchema,
            GetAllProductApplicationMethodsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetAllProductApplicationMethodsGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetAllProductApplicationMethodsGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getAllProductApplicationMethodsGetTotal = qraft.productApplicationMethodsService.getAllProductApplicationMethodsGet.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllProductApplicationMethodsGetSchema,
            GetAllProductApplicationMethodsGetData,
            TInfinite,
            GetAllProductApplicationMethodsGetParameters,
            GetAllProductApplicationMethodsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllProductApplicationMethodsGetSchema,
            GetAllProductApplicationMethodsGetData,
            TInfinite,
            GetAllProductApplicationMethodsGetParameters,
            GetAllProductApplicationMethodsGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getAllProductApplicationMethodsGetResults = qraft.productApplicationMethodsService.getAllProductApplicationMethodsGet.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllProductApplicationMethodsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getAllProductApplicationMethodsGetCombinedResults = qraft.productApplicationMethodsService.getAllProductApplicationMethodsGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllProductApplicationMethodsGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetAllProductApplicationMethodsGetSchema,
          GetAllProductApplicationMethodsGetParameters,
          GetAllProductApplicationMethodsGetData,
          GetAllProductApplicationMethodsGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<GetAllProductApplicationMethodsGetData, GetAllProductApplicationMethodsGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<GetAllProductApplicationMethodsGetData, GetAllProductApplicationMethodsGetError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.productApplicationMethodsService.getAllProductApplicationMethodsGet.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = GetAllProductApplicationMethodsGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetAllProductApplicationMethodsGetSchema,
            GetAllProductApplicationMethodsGetParameters
          >
        | (DeepReadonly<GetAllProductApplicationMethodsGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          GetAllProductApplicationMethodsGetData,
          GetAllProductApplicationMethodsGetError,
          TData,
          ServiceOperationQueryKey<
            GetAllProductApplicationMethodsGetSchema,
            GetAllProductApplicationMethodsGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetAllProductApplicationMethodsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.productApplicationMethodsService.getAllProductApplicationMethodsGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetAllProductApplicationMethodsGetParameters,
      TData = GetAllProductApplicationMethodsGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetAllProductApplicationMethodsGetSchema,
            GetAllProductApplicationMethodsGetParameters
          >
        | (DeepReadonly<GetAllProductApplicationMethodsGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetAllProductApplicationMethodsGetData,
          GetAllProductApplicationMethodsGetError,
          OperationInfiniteData<TData, GetAllProductApplicationMethodsGetParameters>,
          ServiceOperationInfiniteQueryKey<
            GetAllProductApplicationMethodsGetSchema,
            GetAllProductApplicationMethodsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetAllProductApplicationMethodsGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetAllProductApplicationMethodsGetParameters>,
      OperationError<GetAllProductApplicationMethodsGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getAllProductApplicationMethodsGetData = qraft.productApplicationMethodsService.getAllProductApplicationMethodsGet.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllProductApplicationMethodsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getAllProductApplicationMethodsGetCombinedData = qraft.productApplicationMethodsService.getAllProductApplicationMethodsGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllProductApplicationMethodsGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetAllProductApplicationMethodsGetSchema,
          GetAllProductApplicationMethodsGetParameters,
          GetAllProductApplicationMethodsGetData,
          GetAllProductApplicationMethodsGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<GetAllProductApplicationMethodsGetData, GetAllProductApplicationMethodsGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<GetAllProductApplicationMethodsGetData, GetAllProductApplicationMethodsGetError>,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Get All */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAllProductApplicationMethodsGetSchema,
        GetAllProductApplicationMethodsGetData,
        GetAllProductApplicationMethodsGetParameters,
        GetAllProductApplicationMethodsGetError
      > | void
    ): Promise<GetAllProductApplicationMethodsGetData>;
    /** @summary Get All */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAllProductApplicationMethodsGetSchema,
        GetAllProductApplicationMethodsGetData,
        GetAllProductApplicationMethodsGetParameters,
        GetAllProductApplicationMethodsGetError
      > | void
    ): Promise<void>;
    /** @summary Get All */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetAllProductApplicationMethodsGetSchema,
        GetAllProductApplicationMethodsGetData,
        GetAllProductApplicationMethodsGetParameters,
        GetAllProductApplicationMethodsGetError
      > | void
    ): Promise<GetAllProductApplicationMethodsGetData>;
    /** @summary Get All */
    fetchInfiniteQuery<TPageParam extends GetAllProductApplicationMethodsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAllProductApplicationMethodsGetSchema,
        GetAllProductApplicationMethodsGetData,
        GetAllProductApplicationMethodsGetParameters,
        DeepReadonly<TPageParam>,
        GetAllProductApplicationMethodsGetError
      > | void
    ): Promise<
      OperationInfiniteData<GetAllProductApplicationMethodsGetData, GetAllProductApplicationMethodsGetParameters>
    >;
    /** @summary Get All */
    prefetchInfiniteQuery<TPageParam extends GetAllProductApplicationMethodsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAllProductApplicationMethodsGetSchema,
        GetAllProductApplicationMethodsGetData,
        GetAllProductApplicationMethodsGetParameters,
        DeepReadonly<TPageParam>,
        GetAllProductApplicationMethodsGetError
      > | void
    ): Promise<void>;
    /** @summary Get All */
    ensureInfiniteQueryData<TPageParam extends GetAllProductApplicationMethodsGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetAllProductApplicationMethodsGetSchema,
        GetAllProductApplicationMethodsGetData,
        GetAllProductApplicationMethodsGetParameters,
        DeepReadonly<TPageParam>,
        GetAllProductApplicationMethodsGetError
      > | void
    ): Promise<
      OperationInfiniteData<GetAllProductApplicationMethodsGetData, GetAllProductApplicationMethodsGetParameters>
    >;
    /** @summary Get All */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            GetAllProductApplicationMethodsGetSchema,
            GetAllProductApplicationMethodsGetParameters
          >
        | (DeepReadonly<GetAllProductApplicationMethodsGetParameters> | void)
    ): GetAllProductApplicationMethodsGetData | undefined;
    /** @summary Get All */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetAllProductApplicationMethodsGetSchema,
            GetAllProductApplicationMethodsGetParameters
          >
        | (DeepReadonly<GetAllProductApplicationMethodsGetParameters> | void)
    ):
      | OperationInfiniteData<GetAllProductApplicationMethodsGetData, GetAllProductApplicationMethodsGetParameters>
      | undefined;
    /** @summary Get All */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllProductApplicationMethodsGetSchema,
            GetAllProductApplicationMethodsGetData,
            TInfinite,
            GetAllProductApplicationMethodsGetParameters,
            GetAllProductApplicationMethodsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllProductApplicationMethodsGetSchema,
            GetAllProductApplicationMethodsGetData,
            TInfinite,
            GetAllProductApplicationMethodsGetParameters,
            GetAllProductApplicationMethodsGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetAllProductApplicationMethodsGetSchema,
              GetAllProductApplicationMethodsGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    GetAllProductApplicationMethodsGetData,
                    GetAllProductApplicationMethodsGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetAllProductApplicationMethodsGetSchema,
              GetAllProductApplicationMethodsGetParameters
            >,
            data: GetAllProductApplicationMethodsGetData | undefined,
          ]
        >;
    /** @summary Get All */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            GetAllProductApplicationMethodsGetSchema,
            GetAllProductApplicationMethodsGetParameters
          >
        | (DeepReadonly<GetAllProductApplicationMethodsGetParameters> | void)
    ): QueryState<GetAllProductApplicationMethodsGetData, GetAllProductApplicationMethodsGetError> | undefined;
    /** @summary Get All */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetAllProductApplicationMethodsGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetAllProductApplicationMethodsGetSchema,
            GetAllProductApplicationMethodsGetParameters
          >
        | void
    ):
      | QueryState<
          OperationInfiniteData<GetAllProductApplicationMethodsGetData, GetAllProductApplicationMethodsGetParameters>,
          GetAllProductApplicationMethodsGetError
        >
      | undefined;
    /** @summary Get All */
    setQueryData(
      parameters:
        | (DeepReadonly<GetAllProductApplicationMethodsGetParameters> | undefined)
        | ServiceOperationQueryKey<
            GetAllProductApplicationMethodsGetSchema,
            GetAllProductApplicationMethodsGetParameters
          >,
      updater: Updater<
        NoInfer<GetAllProductApplicationMethodsGetData> | undefined,
        NoInfer<DeepReadonly<GetAllProductApplicationMethodsGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetAllProductApplicationMethodsGetData | undefined;
    /** @summary Get All */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<GetAllProductApplicationMethodsGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<
            GetAllProductApplicationMethodsGetSchema,
            GetAllProductApplicationMethodsGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<GetAllProductApplicationMethodsGetData, GetAllProductApplicationMethodsGetParameters>
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                GetAllProductApplicationMethodsGetData,
                GetAllProductApplicationMethodsGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<GetAllProductApplicationMethodsGetData, GetAllProductApplicationMethodsGetParameters>
      | undefined;
    /** @summary Get All */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetAllProductApplicationMethodsGetSchema,
            GetAllProductApplicationMethodsGetData,
            TInfinite,
            GetAllProductApplicationMethodsGetParameters,
            GetAllProductApplicationMethodsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllProductApplicationMethodsGetSchema,
            GetAllProductApplicationMethodsGetData,
            TInfinite,
            GetAllProductApplicationMethodsGetParameters,
            GetAllProductApplicationMethodsGetError
          >,
      updater: Updater<
        NoInfer<GetAllProductApplicationMethodsGetData> | undefined,
        NoInfer<GetAllProductApplicationMethodsGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetAllProductApplicationMethodsGetData | undefined>;
    /** @summary Get All */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetAllProductApplicationMethodsGetSchema,
        GetAllProductApplicationMethodsGetData,
        TInfinite,
        GetAllProductApplicationMethodsGetParameters,
        GetAllProductApplicationMethodsGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Get All */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllProductApplicationMethodsGetSchema,
            GetAllProductApplicationMethodsGetData,
            TInfinite,
            GetAllProductApplicationMethodsGetParameters,
            GetAllProductApplicationMethodsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllProductApplicationMethodsGetSchema,
            GetAllProductApplicationMethodsGetData,
            TInfinite,
            GetAllProductApplicationMethodsGetParameters,
            GetAllProductApplicationMethodsGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Get All */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllProductApplicationMethodsGetSchema,
            GetAllProductApplicationMethodsGetData,
            TInfinite,
            GetAllProductApplicationMethodsGetParameters,
            GetAllProductApplicationMethodsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllProductApplicationMethodsGetSchema,
            GetAllProductApplicationMethodsGetData,
            TInfinite,
            GetAllProductApplicationMethodsGetParameters,
            GetAllProductApplicationMethodsGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Get All */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllProductApplicationMethodsGetSchema,
            GetAllProductApplicationMethodsGetData,
            TInfinite,
            GetAllProductApplicationMethodsGetParameters,
            GetAllProductApplicationMethodsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllProductApplicationMethodsGetSchema,
            GetAllProductApplicationMethodsGetData,
            TInfinite,
            GetAllProductApplicationMethodsGetParameters,
            GetAllProductApplicationMethodsGetError
          >
    ): void;
    /** @summary Get All */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllProductApplicationMethodsGetSchema,
            GetAllProductApplicationMethodsGetData,
            TInfinite,
            GetAllProductApplicationMethodsGetParameters,
            GetAllProductApplicationMethodsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllProductApplicationMethodsGetSchema,
            GetAllProductApplicationMethodsGetData,
            TInfinite,
            GetAllProductApplicationMethodsGetParameters,
            GetAllProductApplicationMethodsGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Get All */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllProductApplicationMethodsGetSchema,
            GetAllProductApplicationMethodsGetData,
            TInfinite,
            GetAllProductApplicationMethodsGetParameters,
            GetAllProductApplicationMethodsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllProductApplicationMethodsGetSchema,
            GetAllProductApplicationMethodsGetData,
            TInfinite,
            GetAllProductApplicationMethodsGetParameters,
            GetAllProductApplicationMethodsGetError
          >
    ): number;
    schema: GetAllProductApplicationMethodsGetSchema;
    types: {
      parameters: GetAllProductApplicationMethodsGetParameters;
      data: GetAllProductApplicationMethodsGetData;
      error: GetAllProductApplicationMethodsGetError;
    };
  };
  /** @summary Create */
  createProductApplicationMethodsPost: {
    /** @summary Create */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        CreateProductApplicationMethodsPostBody,
        CreateProductApplicationMethodsPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: CreateProductApplicationMethodsPostSchema,
        options: ServiceOperationMutationFnOptions<
          CreateProductApplicationMethodsPostBody,
          CreateProductApplicationMethodsPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<CreateProductApplicationMethodsPostData, CreateProductApplicationMethodsPostError>>
    ): Promise<RequestFnResponse<CreateProductApplicationMethodsPostData, CreateProductApplicationMethodsPostError>>;
    /** @summary Create */
    getMutationKey(
      parameters: DeepReadonly<CreateProductApplicationMethodsPostParameters> | void
    ): ServiceOperationMutationKey<
      CreateProductApplicationMethodsPostSchema,
      CreateProductApplicationMethodsPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.productApplicationMethodsService.createProductApplicationMethodsPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.productApplicationMethodsService.createProductApplicationMethodsPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CreateProductApplicationMethodsPostBody, TContext = unknown>(
      parameters: DeepReadonly<CreateProductApplicationMethodsPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateProductApplicationMethodsPostSchema,
        CreateProductApplicationMethodsPostData,
        CreateProductApplicationMethodsPostParameters,
        TVariables,
        OperationError<CreateProductApplicationMethodsPostError>,
        TContext
      >
    ): UseMutationResult<
      CreateProductApplicationMethodsPostData,
      OperationError<CreateProductApplicationMethodsPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.productApplicationMethodsService.createProductApplicationMethodsPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.productApplicationMethodsService.createProductApplicationMethodsPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        CreateProductApplicationMethodsPostBody,
        CreateProductApplicationMethodsPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateProductApplicationMethodsPostSchema,
        CreateProductApplicationMethodsPostData,
        CreateProductApplicationMethodsPostParameters,
        TVariables,
        OperationError<CreateProductApplicationMethodsPostError>,
        TContext
      >
    ): UseMutationResult<
      CreateProductApplicationMethodsPostData,
      OperationError<CreateProductApplicationMethodsPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createProductApplicationMethodsPostTotal = qraft.productApplicationMethodsService.createProductApplicationMethodsPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createProductApplicationMethodsPostTotal = qraft.productApplicationMethodsService.createProductApplicationMethodsPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateProductApplicationMethodsPostBody,
            CreateProductApplicationMethodsPostData,
            CreateProductApplicationMethodsPostParameters,
            OperationError<CreateProductApplicationMethodsPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateProductApplicationMethodsPostSchema,
            CreateProductApplicationMethodsPostBody,
            CreateProductApplicationMethodsPostData,
            CreateProductApplicationMethodsPostParameters,
            OperationError<CreateProductApplicationMethodsPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createProductApplicationMethodsPostPendingMutationVariables = qraft.productApplicationMethodsService.createProductApplicationMethodsPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createProductApplicationMethodsPostMutationData = qraft.productApplicationMethodsService.createProductApplicationMethodsPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateProductApplicationMethodsPostData,
        OperationError<CreateProductApplicationMethodsPostError>,
        MutationVariables<CreateProductApplicationMethodsPostBody, CreateProductApplicationMethodsPostParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateProductApplicationMethodsPostBody,
            CreateProductApplicationMethodsPostData,
            CreateProductApplicationMethodsPostParameters,
            OperationError<CreateProductApplicationMethodsPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateProductApplicationMethodsPostSchema,
            CreateProductApplicationMethodsPostBody,
            CreateProductApplicationMethodsPostData,
            CreateProductApplicationMethodsPostParameters,
            OperationError<CreateProductApplicationMethodsPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateProductApplicationMethodsPostData,
          OperationError<CreateProductApplicationMethodsPostError>,
          MutationVariables<CreateProductApplicationMethodsPostBody, CreateProductApplicationMethodsPostParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Create */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateProductApplicationMethodsPostBody,
            CreateProductApplicationMethodsPostData,
            CreateProductApplicationMethodsPostParameters,
            OperationError<CreateProductApplicationMethodsPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateProductApplicationMethodsPostSchema,
            CreateProductApplicationMethodsPostBody,
            CreateProductApplicationMethodsPostData,
            CreateProductApplicationMethodsPostParameters,
            OperationError<CreateProductApplicationMethodsPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.productApplicationMethodsService.createProductApplicationMethodsPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.productApplicationMethodsService.createProductApplicationMethodsPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateProductApplicationMethodsPostBody,
              CreateProductApplicationMethodsPostData,
              CreateProductApplicationMethodsPostParameters,
              OperationError<CreateProductApplicationMethodsPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateProductApplicationMethodsPostSchema,
              CreateProductApplicationMethodsPostBody,
              CreateProductApplicationMethodsPostData,
              CreateProductApplicationMethodsPostParameters,
              OperationError<CreateProductApplicationMethodsPostError>,
              TContext
            >
      ):
        | Mutation<
            CreateProductApplicationMethodsPostData,
            CreateProductApplicationMethodsPostError,
            MutationVariables<CreateProductApplicationMethodsPostBody, CreateProductApplicationMethodsPostParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateProductApplicationMethodsPostBody,
              CreateProductApplicationMethodsPostData,
              CreateProductApplicationMethodsPostParameters,
              OperationError<CreateProductApplicationMethodsPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateProductApplicationMethodsPostSchema,
              CreateProductApplicationMethodsPostBody,
              CreateProductApplicationMethodsPostData,
              CreateProductApplicationMethodsPostParameters,
              OperationError<CreateProductApplicationMethodsPostError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateProductApplicationMethodsPostData,
          CreateProductApplicationMethodsPostError,
          MutationVariables<CreateProductApplicationMethodsPostBody, CreateProductApplicationMethodsPostParameters>,
          TContext
        >
      >;
    };
    schema: CreateProductApplicationMethodsPostSchema;
    types: {
      parameters: CreateProductApplicationMethodsPostParameters;
      data: CreateProductApplicationMethodsPostData;
      error: CreateProductApplicationMethodsPostError;
      body: CreateProductApplicationMethodsPostBody;
    };
  };
  /** @summary Update */
  updateProductApplicationMethodsProductApplicationMethodIdPatch: {
    /** @summary Update */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        UpdateProductApplicationMethodsProductApplicationMethodIdPatchBody,
        UpdateProductApplicationMethodsProductApplicationMethodIdPatchParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: UpdateProductApplicationMethodsProductApplicationMethodIdPatchSchema,
        options: ServiceOperationMutationFnOptions<
          UpdateProductApplicationMethodsProductApplicationMethodIdPatchBody,
          UpdateProductApplicationMethodsProductApplicationMethodIdPatchParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          UpdateProductApplicationMethodsProductApplicationMethodIdPatchData,
          UpdateProductApplicationMethodsProductApplicationMethodIdPatchError
        >
      >
    ): Promise<
      RequestFnResponse<
        UpdateProductApplicationMethodsProductApplicationMethodIdPatchData,
        UpdateProductApplicationMethodsProductApplicationMethodIdPatchError
      >
    >;
    /** @summary Update */
    getMutationKey(
      parameters: DeepReadonly<UpdateProductApplicationMethodsProductApplicationMethodIdPatchParameters> | void
    ): ServiceOperationMutationKey<
      UpdateProductApplicationMethodsProductApplicationMethodIdPatchSchema,
      UpdateProductApplicationMethodsProductApplicationMethodIdPatchParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.productApplicationMethodsService.updateProductApplicationMethodsProductApplicationMethodIdPatch.useMutation({
     *     path: {
     *         product_application_method_id: productApplicationMethodId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.productApplicationMethodsService.updateProductApplicationMethodsProductApplicationMethodIdPatch.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         product_application_method_id: productApplicationMethodId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends UpdateProductApplicationMethodsProductApplicationMethodIdPatchBody,
      TContext = unknown,
    >(
      parameters: DeepReadonly<UpdateProductApplicationMethodsProductApplicationMethodIdPatchParameters>,
      options?: ServiceOperationUseMutationOptions<
        UpdateProductApplicationMethodsProductApplicationMethodIdPatchSchema,
        UpdateProductApplicationMethodsProductApplicationMethodIdPatchData,
        UpdateProductApplicationMethodsProductApplicationMethodIdPatchParameters,
        TVariables,
        OperationError<UpdateProductApplicationMethodsProductApplicationMethodIdPatchError>,
        TContext
      >
    ): UseMutationResult<
      UpdateProductApplicationMethodsProductApplicationMethodIdPatchData,
      OperationError<UpdateProductApplicationMethodsProductApplicationMethodIdPatchError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.productApplicationMethodsService.updateProductApplicationMethodsProductApplicationMethodIdPatch.useMutation({
     *     path: {
     *         product_application_method_id: productApplicationMethodId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.productApplicationMethodsService.updateProductApplicationMethodsProductApplicationMethodIdPatch.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         product_application_method_id: productApplicationMethodId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        UpdateProductApplicationMethodsProductApplicationMethodIdPatchBody,
        UpdateProductApplicationMethodsProductApplicationMethodIdPatchParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        UpdateProductApplicationMethodsProductApplicationMethodIdPatchSchema,
        UpdateProductApplicationMethodsProductApplicationMethodIdPatchData,
        UpdateProductApplicationMethodsProductApplicationMethodIdPatchParameters,
        TVariables,
        OperationError<UpdateProductApplicationMethodsProductApplicationMethodIdPatchError>,
        TContext
      >
    ): UseMutationResult<
      UpdateProductApplicationMethodsProductApplicationMethodIdPatchData,
      OperationError<UpdateProductApplicationMethodsProductApplicationMethodIdPatchError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const updateProductApplicationMethodsProductApplicationMethodIdPatchTotal = qraft.productApplicationMethodsService.updateProductApplicationMethodsProductApplicationMethodIdPatch.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const updateProductApplicationMethodsProductApplicationMethodIdPatchTotal = qraft.productApplicationMethodsService.updateProductApplicationMethodsProductApplicationMethodIdPatch.useIsMutating({
     *     parameters: {
     *         path: {
     *             product_application_method_id: productApplicationMethodId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            UpdateProductApplicationMethodsProductApplicationMethodIdPatchBody,
            UpdateProductApplicationMethodsProductApplicationMethodIdPatchData,
            UpdateProductApplicationMethodsProductApplicationMethodIdPatchParameters,
            OperationError<UpdateProductApplicationMethodsProductApplicationMethodIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateProductApplicationMethodsProductApplicationMethodIdPatchSchema,
            UpdateProductApplicationMethodsProductApplicationMethodIdPatchBody,
            UpdateProductApplicationMethodsProductApplicationMethodIdPatchData,
            UpdateProductApplicationMethodsProductApplicationMethodIdPatchParameters,
            OperationError<UpdateProductApplicationMethodsProductApplicationMethodIdPatchError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const updateProductApplicationMethodsProductApplicationMethodIdPatchPendingMutationVariables = qraft.productApplicationMethodsService.updateProductApplicationMethodsProductApplicationMethodIdPatch.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const updateProductApplicationMethodsProductApplicationMethodIdPatchMutationData = qraft.productApplicationMethodsService.updateProductApplicationMethodsProductApplicationMethodIdPatch.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 product_application_method_id: productApplicationMethodId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        UpdateProductApplicationMethodsProductApplicationMethodIdPatchData,
        OperationError<UpdateProductApplicationMethodsProductApplicationMethodIdPatchError>,
        MutationVariables<
          UpdateProductApplicationMethodsProductApplicationMethodIdPatchBody,
          UpdateProductApplicationMethodsProductApplicationMethodIdPatchParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            UpdateProductApplicationMethodsProductApplicationMethodIdPatchBody,
            UpdateProductApplicationMethodsProductApplicationMethodIdPatchData,
            UpdateProductApplicationMethodsProductApplicationMethodIdPatchParameters,
            OperationError<UpdateProductApplicationMethodsProductApplicationMethodIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateProductApplicationMethodsProductApplicationMethodIdPatchSchema,
            UpdateProductApplicationMethodsProductApplicationMethodIdPatchBody,
            UpdateProductApplicationMethodsProductApplicationMethodIdPatchData,
            UpdateProductApplicationMethodsProductApplicationMethodIdPatchParameters,
            OperationError<UpdateProductApplicationMethodsProductApplicationMethodIdPatchError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          UpdateProductApplicationMethodsProductApplicationMethodIdPatchData,
          OperationError<UpdateProductApplicationMethodsProductApplicationMethodIdPatchError>,
          MutationVariables<
            UpdateProductApplicationMethodsProductApplicationMethodIdPatchBody,
            UpdateProductApplicationMethodsProductApplicationMethodIdPatchParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Update */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            UpdateProductApplicationMethodsProductApplicationMethodIdPatchBody,
            UpdateProductApplicationMethodsProductApplicationMethodIdPatchData,
            UpdateProductApplicationMethodsProductApplicationMethodIdPatchParameters,
            OperationError<UpdateProductApplicationMethodsProductApplicationMethodIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateProductApplicationMethodsProductApplicationMethodIdPatchSchema,
            UpdateProductApplicationMethodsProductApplicationMethodIdPatchBody,
            UpdateProductApplicationMethodsProductApplicationMethodIdPatchData,
            UpdateProductApplicationMethodsProductApplicationMethodIdPatchParameters,
            OperationError<UpdateProductApplicationMethodsProductApplicationMethodIdPatchError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.productApplicationMethodsService.updateProductApplicationMethodsProductApplicationMethodIdPatch.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             product_application_method_id: productApplicationMethodId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.productApplicationMethodsService.updateProductApplicationMethodsProductApplicationMethodIdPatch.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              UpdateProductApplicationMethodsProductApplicationMethodIdPatchBody,
              UpdateProductApplicationMethodsProductApplicationMethodIdPatchData,
              UpdateProductApplicationMethodsProductApplicationMethodIdPatchParameters,
              OperationError<UpdateProductApplicationMethodsProductApplicationMethodIdPatchError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateProductApplicationMethodsProductApplicationMethodIdPatchSchema,
              UpdateProductApplicationMethodsProductApplicationMethodIdPatchBody,
              UpdateProductApplicationMethodsProductApplicationMethodIdPatchData,
              UpdateProductApplicationMethodsProductApplicationMethodIdPatchParameters,
              OperationError<UpdateProductApplicationMethodsProductApplicationMethodIdPatchError>,
              TContext
            >
      ):
        | Mutation<
            UpdateProductApplicationMethodsProductApplicationMethodIdPatchData,
            UpdateProductApplicationMethodsProductApplicationMethodIdPatchError,
            MutationVariables<
              UpdateProductApplicationMethodsProductApplicationMethodIdPatchBody,
              UpdateProductApplicationMethodsProductApplicationMethodIdPatchParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              UpdateProductApplicationMethodsProductApplicationMethodIdPatchBody,
              UpdateProductApplicationMethodsProductApplicationMethodIdPatchData,
              UpdateProductApplicationMethodsProductApplicationMethodIdPatchParameters,
              OperationError<UpdateProductApplicationMethodsProductApplicationMethodIdPatchError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateProductApplicationMethodsProductApplicationMethodIdPatchSchema,
              UpdateProductApplicationMethodsProductApplicationMethodIdPatchBody,
              UpdateProductApplicationMethodsProductApplicationMethodIdPatchData,
              UpdateProductApplicationMethodsProductApplicationMethodIdPatchParameters,
              OperationError<UpdateProductApplicationMethodsProductApplicationMethodIdPatchError>,
              TContext
            >
      ): Array<
        Mutation<
          UpdateProductApplicationMethodsProductApplicationMethodIdPatchData,
          UpdateProductApplicationMethodsProductApplicationMethodIdPatchError,
          MutationVariables<
            UpdateProductApplicationMethodsProductApplicationMethodIdPatchBody,
            UpdateProductApplicationMethodsProductApplicationMethodIdPatchParameters
          >,
          TContext
        >
      >;
    };
    schema: UpdateProductApplicationMethodsProductApplicationMethodIdPatchSchema;
    types: {
      parameters: UpdateProductApplicationMethodsProductApplicationMethodIdPatchParameters;
      data: UpdateProductApplicationMethodsProductApplicationMethodIdPatchData;
      error: UpdateProductApplicationMethodsProductApplicationMethodIdPatchError;
      body: UpdateProductApplicationMethodsProductApplicationMethodIdPatchBody;
    };
  };
  /** @summary Delete */
  deleteProductApplicationMethodsProductApplicationMethodIdDelete: {
    /** @summary Delete */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        DeleteProductApplicationMethodsProductApplicationMethodIdDeleteBody,
        DeleteProductApplicationMethodsProductApplicationMethodIdDeleteParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: DeleteProductApplicationMethodsProductApplicationMethodIdDeleteSchema,
        options: ServiceOperationMutationFnOptions<
          DeleteProductApplicationMethodsProductApplicationMethodIdDeleteBody,
          DeleteProductApplicationMethodsProductApplicationMethodIdDeleteParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          DeleteProductApplicationMethodsProductApplicationMethodIdDeleteData,
          DeleteProductApplicationMethodsProductApplicationMethodIdDeleteError
        >
      >
    ): Promise<
      RequestFnResponse<
        DeleteProductApplicationMethodsProductApplicationMethodIdDeleteData,
        DeleteProductApplicationMethodsProductApplicationMethodIdDeleteError
      >
    >;
    /** @summary Delete */
    getMutationKey(
      parameters: DeepReadonly<DeleteProductApplicationMethodsProductApplicationMethodIdDeleteParameters> | void
    ): ServiceOperationMutationKey<
      DeleteProductApplicationMethodsProductApplicationMethodIdDeleteSchema,
      DeleteProductApplicationMethodsProductApplicationMethodIdDeleteParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Delete
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.productApplicationMethodsService.deleteProductApplicationMethodsProductApplicationMethodIdDelete.useMutation({
     *     path: {
     *         product_application_method_id: productApplicationMethodId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.productApplicationMethodsService.deleteProductApplicationMethodsProductApplicationMethodIdDelete.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         product_application_method_id: productApplicationMethodId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends DeleteProductApplicationMethodsProductApplicationMethodIdDeleteBody,
      TContext = unknown,
    >(
      parameters: DeepReadonly<DeleteProductApplicationMethodsProductApplicationMethodIdDeleteParameters>,
      options?: ServiceOperationUseMutationOptions<
        DeleteProductApplicationMethodsProductApplicationMethodIdDeleteSchema,
        DeleteProductApplicationMethodsProductApplicationMethodIdDeleteData,
        DeleteProductApplicationMethodsProductApplicationMethodIdDeleteParameters,
        TVariables,
        OperationError<DeleteProductApplicationMethodsProductApplicationMethodIdDeleteError>,
        TContext
      >
    ): UseMutationResult<
      DeleteProductApplicationMethodsProductApplicationMethodIdDeleteData,
      OperationError<DeleteProductApplicationMethodsProductApplicationMethodIdDeleteError>,
      TVariables | void,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Delete
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.productApplicationMethodsService.deleteProductApplicationMethodsProductApplicationMethodIdDelete.useMutation({
     *     path: {
     *         product_application_method_id: productApplicationMethodId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.productApplicationMethodsService.deleteProductApplicationMethodsProductApplicationMethodIdDelete.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         product_application_method_id: productApplicationMethodId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        DeleteProductApplicationMethodsProductApplicationMethodIdDeleteBody,
        DeleteProductApplicationMethodsProductApplicationMethodIdDeleteParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        DeleteProductApplicationMethodsProductApplicationMethodIdDeleteSchema,
        DeleteProductApplicationMethodsProductApplicationMethodIdDeleteData,
        DeleteProductApplicationMethodsProductApplicationMethodIdDeleteParameters,
        TVariables,
        OperationError<DeleteProductApplicationMethodsProductApplicationMethodIdDeleteError>,
        TContext
      >
    ): UseMutationResult<
      DeleteProductApplicationMethodsProductApplicationMethodIdDeleteData,
      OperationError<DeleteProductApplicationMethodsProductApplicationMethodIdDeleteError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Delete
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const deleteProductApplicationMethodsProductApplicationMethodIdDeleteTotal = qraft.productApplicationMethodsService.deleteProductApplicationMethodsProductApplicationMethodIdDelete.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const deleteProductApplicationMethodsProductApplicationMethodIdDeleteTotal = qraft.productApplicationMethodsService.deleteProductApplicationMethodsProductApplicationMethodIdDelete.useIsMutating({
     *     parameters: {
     *         path: {
     *             product_application_method_id: productApplicationMethodId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            DeleteProductApplicationMethodsProductApplicationMethodIdDeleteBody,
            DeleteProductApplicationMethodsProductApplicationMethodIdDeleteData,
            DeleteProductApplicationMethodsProductApplicationMethodIdDeleteParameters,
            OperationError<DeleteProductApplicationMethodsProductApplicationMethodIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            DeleteProductApplicationMethodsProductApplicationMethodIdDeleteSchema,
            DeleteProductApplicationMethodsProductApplicationMethodIdDeleteBody,
            DeleteProductApplicationMethodsProductApplicationMethodIdDeleteData,
            DeleteProductApplicationMethodsProductApplicationMethodIdDeleteParameters,
            OperationError<DeleteProductApplicationMethodsProductApplicationMethodIdDeleteError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Delete
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const deleteProductApplicationMethodsProductApplicationMethodIdDeletePendingMutationVariables = qraft.productApplicationMethodsService.deleteProductApplicationMethodsProductApplicationMethodIdDelete.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const deleteProductApplicationMethodsProductApplicationMethodIdDeleteMutationData = qraft.productApplicationMethodsService.deleteProductApplicationMethodsProductApplicationMethodIdDelete.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 product_application_method_id: productApplicationMethodId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        DeleteProductApplicationMethodsProductApplicationMethodIdDeleteData,
        OperationError<DeleteProductApplicationMethodsProductApplicationMethodIdDeleteError>,
        MutationVariables<
          DeleteProductApplicationMethodsProductApplicationMethodIdDeleteBody,
          DeleteProductApplicationMethodsProductApplicationMethodIdDeleteParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            DeleteProductApplicationMethodsProductApplicationMethodIdDeleteBody,
            DeleteProductApplicationMethodsProductApplicationMethodIdDeleteData,
            DeleteProductApplicationMethodsProductApplicationMethodIdDeleteParameters,
            OperationError<DeleteProductApplicationMethodsProductApplicationMethodIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            DeleteProductApplicationMethodsProductApplicationMethodIdDeleteSchema,
            DeleteProductApplicationMethodsProductApplicationMethodIdDeleteBody,
            DeleteProductApplicationMethodsProductApplicationMethodIdDeleteData,
            DeleteProductApplicationMethodsProductApplicationMethodIdDeleteParameters,
            OperationError<DeleteProductApplicationMethodsProductApplicationMethodIdDeleteError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          DeleteProductApplicationMethodsProductApplicationMethodIdDeleteData,
          OperationError<DeleteProductApplicationMethodsProductApplicationMethodIdDeleteError>,
          MutationVariables<
            DeleteProductApplicationMethodsProductApplicationMethodIdDeleteBody,
            DeleteProductApplicationMethodsProductApplicationMethodIdDeleteParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Delete */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            DeleteProductApplicationMethodsProductApplicationMethodIdDeleteBody,
            DeleteProductApplicationMethodsProductApplicationMethodIdDeleteData,
            DeleteProductApplicationMethodsProductApplicationMethodIdDeleteParameters,
            OperationError<DeleteProductApplicationMethodsProductApplicationMethodIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            DeleteProductApplicationMethodsProductApplicationMethodIdDeleteSchema,
            DeleteProductApplicationMethodsProductApplicationMethodIdDeleteBody,
            DeleteProductApplicationMethodsProductApplicationMethodIdDeleteData,
            DeleteProductApplicationMethodsProductApplicationMethodIdDeleteParameters,
            OperationError<DeleteProductApplicationMethodsProductApplicationMethodIdDeleteError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Delete
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.productApplicationMethodsService.deleteProductApplicationMethodsProductApplicationMethodIdDelete.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             product_application_method_id: productApplicationMethodId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.productApplicationMethodsService.deleteProductApplicationMethodsProductApplicationMethodIdDelete.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              DeleteProductApplicationMethodsProductApplicationMethodIdDeleteBody,
              DeleteProductApplicationMethodsProductApplicationMethodIdDeleteData,
              DeleteProductApplicationMethodsProductApplicationMethodIdDeleteParameters,
              OperationError<DeleteProductApplicationMethodsProductApplicationMethodIdDeleteError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              DeleteProductApplicationMethodsProductApplicationMethodIdDeleteSchema,
              DeleteProductApplicationMethodsProductApplicationMethodIdDeleteBody,
              DeleteProductApplicationMethodsProductApplicationMethodIdDeleteData,
              DeleteProductApplicationMethodsProductApplicationMethodIdDeleteParameters,
              OperationError<DeleteProductApplicationMethodsProductApplicationMethodIdDeleteError>,
              TContext
            >
      ):
        | Mutation<
            DeleteProductApplicationMethodsProductApplicationMethodIdDeleteData,
            DeleteProductApplicationMethodsProductApplicationMethodIdDeleteError,
            MutationVariables<
              DeleteProductApplicationMethodsProductApplicationMethodIdDeleteBody,
              DeleteProductApplicationMethodsProductApplicationMethodIdDeleteParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              DeleteProductApplicationMethodsProductApplicationMethodIdDeleteBody,
              DeleteProductApplicationMethodsProductApplicationMethodIdDeleteData,
              DeleteProductApplicationMethodsProductApplicationMethodIdDeleteParameters,
              OperationError<DeleteProductApplicationMethodsProductApplicationMethodIdDeleteError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              DeleteProductApplicationMethodsProductApplicationMethodIdDeleteSchema,
              DeleteProductApplicationMethodsProductApplicationMethodIdDeleteBody,
              DeleteProductApplicationMethodsProductApplicationMethodIdDeleteData,
              DeleteProductApplicationMethodsProductApplicationMethodIdDeleteParameters,
              OperationError<DeleteProductApplicationMethodsProductApplicationMethodIdDeleteError>,
              TContext
            >
      ): Array<
        Mutation<
          DeleteProductApplicationMethodsProductApplicationMethodIdDeleteData,
          DeleteProductApplicationMethodsProductApplicationMethodIdDeleteError,
          MutationVariables<
            DeleteProductApplicationMethodsProductApplicationMethodIdDeleteBody,
            DeleteProductApplicationMethodsProductApplicationMethodIdDeleteParameters
          >,
          TContext
        >
      >;
    };
    schema: DeleteProductApplicationMethodsProductApplicationMethodIdDeleteSchema;
    types: {
      parameters: DeleteProductApplicationMethodsProductApplicationMethodIdDeleteParameters;
      data: DeleteProductApplicationMethodsProductApplicationMethodIdDeleteData;
      error: DeleteProductApplicationMethodsProductApplicationMethodIdDeleteError;
      body: DeleteProductApplicationMethodsProductApplicationMethodIdDeleteBody;
    };
  };
}
/** @summary Get All */
export const getAllProductApplicationMethodsGet = {
  schema: {
    method: 'get',
    url: '/product_application_methods',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetAllProductApplicationMethodsGetSchema;
  [QraftServiceOperationsToken]: ProductApplicationMethodsService['getAllProductApplicationMethodsGet'];
};
/** @summary Create */
export const createProductApplicationMethodsPost = {
  schema: {
    method: 'post',
    url: '/product_application_methods',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: CreateProductApplicationMethodsPostSchema;
  [QraftServiceOperationsToken]: ProductApplicationMethodsService['createProductApplicationMethodsPost'];
};
/** @summary Update */
export const updateProductApplicationMethodsProductApplicationMethodIdPatch = {
  schema: {
    method: 'patch',
    url: '/product_application_methods/{product_application_method_id}',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: UpdateProductApplicationMethodsProductApplicationMethodIdPatchSchema;
  [QraftServiceOperationsToken]: ProductApplicationMethodsService['updateProductApplicationMethodsProductApplicationMethodIdPatch'];
};
/** @summary Delete */
export const deleteProductApplicationMethodsProductApplicationMethodIdDelete = {
  schema: {
    method: 'delete',
    url: '/product_application_methods/{product_application_method_id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: DeleteProductApplicationMethodsProductApplicationMethodIdDeleteSchema;
  [QraftServiceOperationsToken]: ProductApplicationMethodsService['deleteProductApplicationMethodsProductApplicationMethodIdDelete'];
};
export const productApplicationMethodsService = {
  getAllProductApplicationMethodsGet,
  createProductApplicationMethodsPost,
  updateProductApplicationMethodsProductApplicationMethodIdPatch,
  deleteProductApplicationMethodsProductApplicationMethodIdDelete,
} as const;
type GetAllProductApplicationMethodsGetSchema = {
  method: 'get';
  url: '/product_application_methods';
  security: ['HTTPBearer'];
};
type GetAllProductApplicationMethodsGetParameters = undefined;
type GetAllProductApplicationMethodsGetData =
  paths['/product_application_methods']['get']['responses']['200']['content']['application/json'];
type GetAllProductApplicationMethodsGetError = unknown;
type CreateProductApplicationMethodsPostSchema = {
  method: 'post';
  url: '/product_application_methods';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type CreateProductApplicationMethodsPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CreateProductApplicationMethodsPostData =
  paths['/product_application_methods']['post']['responses']['201']['content']['application/json'];
type CreateProductApplicationMethodsPostError =
  paths['/product_application_methods']['post']['responses']['422']['content']['application/json'];
type CreateProductApplicationMethodsPostBody =
  paths['/product_application_methods']['post']['requestBody']['content']['application/json'];
type UpdateProductApplicationMethodsProductApplicationMethodIdPatchSchema = {
  method: 'patch';
  url: '/product_application_methods/{product_application_method_id}';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type UpdateProductApplicationMethodsProductApplicationMethodIdPatchParameters =
  paths['/product_application_methods/{product_application_method_id}']['patch']['parameters'];
type UpdateProductApplicationMethodsProductApplicationMethodIdPatchData =
  paths['/product_application_methods/{product_application_method_id}']['patch']['responses']['200']['content']['application/json'];
type UpdateProductApplicationMethodsProductApplicationMethodIdPatchError =
  paths['/product_application_methods/{product_application_method_id}']['patch']['responses']['422']['content']['application/json'];
type UpdateProductApplicationMethodsProductApplicationMethodIdPatchBody =
  paths['/product_application_methods/{product_application_method_id}']['patch']['requestBody']['content']['application/json'];
type DeleteProductApplicationMethodsProductApplicationMethodIdDeleteSchema = {
  method: 'delete';
  url: '/product_application_methods/{product_application_method_id}';
  security: ['HTTPBearer'];
};
type DeleteProductApplicationMethodsProductApplicationMethodIdDeleteParameters =
  paths['/product_application_methods/{product_application_method_id}']['delete']['parameters'];
type DeleteProductApplicationMethodsProductApplicationMethodIdDeleteData = null;
type DeleteProductApplicationMethodsProductApplicationMethodIdDeleteError =
  paths['/product_application_methods/{product_application_method_id}']['delete']['responses']['422']['content']['application/json'];
type DeleteProductApplicationMethodsProductApplicationMethodIdDeleteBody = undefined;
